<!-- Uploaded to: SVG Repo, www.svgrepo.com, Transformed by: SVG Repo Mixer Tools -->
<svg
	width="30px"
	height="30px"
	viewBox="0 0 48 48"
	data-name="Layer 1"
	id="Layer_1"
	xmlns="http://www.w3.org/2000/svg"
	fill="currentColor"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<defs>
			<style>
				.cls-1,
				.cls-2 {
					fill: none;
					stroke: currentColor;
					stroke-linecap: round;
					stroke-linejoin: round;
					stroke-width: 2px;
				}
				.cls-1 {
					fill-rule: evenodd;
				}
			</style>
		</defs>

		<title />

		<polyline class="cls-1" points="1 1 1 47 47 47" />

		<circle class="cls-2" cx="8" cy="24" r="2" />

		<circle class="cls-2" cx="20" cy="30" r="2" />

		<circle class="cls-2" cx="31" cy="21" r="2" />

		<circle class="cls-2" cx="42" cy="25" r="2" />

		<line class="cls-2" x1="10" x2="18" y1="25" y2="29" />

		<line class="cls-2" x1="22" x2="29" y1="29" y2="22" />

		<line class="cls-2" x1="33" x2="40" y1="22" y2="24" />
	</g>
</svg>
